import type { HomeBlock } from "@/lib/widget-config";
import { renderInlineMarkdown } from "../helpers";

export function RichTextBlock({ block }: { block: Extract<HomeBlock, { kind: "rich-text" }> }) {
  // Lightweight inline render — bold / italic / links / line breaks.
  // The operator editor sanitises on save; this is a minimal subset
  // renderer (no headings / images / scripts, matching the BE doc's
  // allowlist) so the Home tab doesn't pull the full markdown stack.
  return (
    <div className="px-2 text-sm leading-relaxed text-wx-fg-muted [&_a]:text-wx-primary [&_a]:underline">
      {renderInlineMarkdown(block.markdown)}
    </div>
  );
}
